
export interface HelpVideo {
    readonly key: string;
    readonly path: string;
    readonly label: string;
    readonly weight: number;
    readonly videoUrl: string;
}

export const HelpVideo = (key: string, path: string, label: string, weight: number, videoUrl: string) =>
    Object.freeze({ key, path, label, weight, videoUrl }) as HelpVideo;
